import { gql } from '@apollo/client';

export const lineItemForRefund = gql`
  fragment lineItemForRefund on RefundItems {
    id
    adjustments {
      amount
      reason
      type
      percent
      promotionId
    }
    adjustmentDetails {
      amount
      reason
      type
      percent
      promotionId
    }
    invoiceLineItemId
    entitlementNumber
    entitlementId
    quantity
    description
    total
    totalExTax
    totalTax
    taxRate
    taxableAmount
    taxExemptAmount
    platform
    productId
    edition
    productName
    billingCycle
    isAddOn
    pricingPlanId
    pricingPlan {
      status
      pricingPlanType
      type
      billingFrequency
      status
      pricingPlanType
      id
      currency
      description
      tiers {
        unitAmount
        flatAmount
        floor
        ceiling
      }
    }
    editionWhileRefund
    refundToCustomerBalance
    taxItems {
      id
      taxPercent
      tax
      taxId
      taxAmountLabel
      taxIdLabel
    }
    logoId
    margins {
      amount
      percent
      type
    }
    promotions {
      id
      title
      type
      benefits {
        duration
        benefitType
        subBenefitType
        value
        iterations
      }
      status
    }
  }
`;

const productAppRefundItem = gql`
  ${lineItemForRefund}
  fragment productAppRefundItem on ProductAppRefundItem {
    products {
      ...lineItemForRefund
    }
    apps {
      ...lineItemForRefund
    }
    addOns @include(if: $fetchAddOns) {
      ...lineItemForRefund
    }
  }
`;

export const coupledRefundItemsForRefund = gql`
  ${productAppRefundItem}
  fragment coupledRefundItemsForRefund on ProductAppRefundItemData {
    jira {
      ...productAppRefundItem
    }
    confluence {
      ...productAppRefundItem
    }
    statuspage {
      ...productAppRefundItem
    }
    atlassianGuard @include(if: $fetchAGPAddon) {
      ...productAppRefundItem
    }
    other {
      ...productAppRefundItem
    }
  }
`;
